import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  TextField, MenuItem, Button, Alert,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import { useMutation } from "@apollo/client";
import BookingTypeHostAvailability from "./bookingTypeHostAvailability";
import BufferTimeSettings from "./bufferTimeSettings";
import Privacy from "./privacy";
import DateRangeView from "./dateRangeView";
import RecurringView from "./recurringView";
import { useBookingTypeContext } from "./bookingTypeProvider";
import CustomDialog from "./useCloseConfirmation";
import { Recurring } from "../../../../../platform/types";
import { useSelectedBusiness } from "../../../../../platform/redux/store";
import { DELETE_WORKING_HOUR_GROUP, UPDATE_WORKING_HOUR_GROUP } from "../../../../../platform/graphql/mutations";
import { UserContext } from "../../../../../platform/components/auth/auth-context";
import GenericTooltip from "../../../../../platform/components/common/genericToolTip";
import AccessRestrictedButton from "../../../../../platform/util/accessRestrictedButton";
import { UpgradePlan } from "../../../../../platform/util/upgrade/upgradePlan";
import { useCalendarPreferences } from '../../../../../platform/util/calendarPreferences';


const BookingTypeTime = () => {
  const {
    isUpdateMode,
    showSection, 
    handleSubmit,
    setUpdating,
    bookingApproval,
    bookingType,
    isScheduleSettings,
    setIsScheduleSettings,
    onClose,
    getBookingCategory, 
    isDisabled,
    hasAdvancedBookingAccess,
  } = useBookingTypeContext(); 
  const [selectedOption, setSelectedOption] = useState(bookingType?.recurring !== Recurring.NONE ? 'recurrence' : 'non-recurrence');
  const [recurring, setRecurring] = useState(bookingType?.recurring ?? Recurring.WEEKLY)
  const [recurringInterval, setRecurringInterval] = useState(bookingType?.recurringInterval || 1);
  const [start, setStart] = useState(bookingType?.start)
  const [end, setEnd] = useState(bookingType?.end)
  const [checkPlanNeeded, setCheckPlanNeeded] = useState(false);
  const [upgradeFeature, setUpgradeFeature] = useState("");
  const userContext = useContext(UserContext);
  const providerUser = userContext.providerUser;
  const selectedBusiness = useSelectedBusiness();
  const preferences = useCalendarPreferences(selectedBusiness?.businessBasic?.id);
  const [calendarSystem, setCalendarSystem] = useState(bookingType?.calendarSystem || 'gregory');
  const [datesValid, setDatesValid] = useState(true);
  useEffect(() => { if (!bookingType?.id) setCalendarSystem(preferences.defaultCalendar === 'ethiopic' || preferences.displayCalendar === 'ethiopic' ? 'ethiopic' : 'gregory'); }, [bookingType?.id, preferences.defaultCalendar, preferences.displayCalendar]);

  const standardPlanRequired = 2;
  const handleOptionChange = (event) => {
    const { value } = event.target;
    if (value === "recurrence") {
      if (!hasAdvancedBookingAccess) {
        setUpgradeFeature("Recurring schedules");
        setCheckPlanNeeded(true);
      } else {
        setCheckPlanNeeded(false);
        setSelectedOption(value);
      setRecurring(Recurring.DAILY);
      }
    } else {
      setSelectedOption(value);
      setRecurring(Recurring.NONE);
    }
  }; 
  const [updateWorkingHourGroup] = useMutation(UPDATE_WORKING_HOUR_GROUP);
  const [deleteWorkingHourGroup] = useMutation(DELETE_WORKING_HOUR_GROUP);
  const [custom, setCustom] = useState(false);
  const businessStaffs = selectedBusiness?.businessStaffs;
  const businessBookingTypes = selectedBusiness?.businessBookingTypes;


  const privateVisiblity = "private";
  const [visibility, setVisibility] = useState(bookingType?.isVisibleToStaff ? "publicForStaff" : privateVisiblity); // Set the default visibility option to "Private"
  const [isVisibleOnBookingPage, setIsVisibleOnBookingPage] = useState(bookingType?.displayOnBookingPage ?? false); // Default to not visible on Booking Page
  const [isPublic, setIsPublic] = useState(bookingType?.isPublic ?? false); // Default to not visible on Booking Page

  const selectedBookingType = businessBookingTypes?.find(
    (bType) => Number(bType.id) === Number(bookingType?.id)
  );

  const allStaffs = businessStaffs
 
  const getDefaultGroupId = (staffId) => {
    const targetStaff = businessStaffs?.find(
      (staff) => Number(staff.id) === Number(staffId)
    );
    const matchingGroup = targetStaff?.workingHourGroups.find(
      (workingHourGroup) => workingHourGroup.def === true
    );

    return Number(matchingGroup?.id);
  };
  function getSelectedGroupIdForStaff(staffId) {
    let defaultGroupId = null;
    var selectedStaff = null;
    if (bookingType) {
      selectedStaff = selectedBookingType?.assignedStaffs?.find(
        (staff) => Number(staff.staffId) === Number(staffId)
      );
      if (selectedStaff) return Number(selectedStaff.groupId);
    }

    defaultGroupId = getDefaultGroupId(staffId);

    return Number(defaultGroupId);
  }
  const [groupId, setGroupId] = useState(
    getSelectedGroupIdForStaff(providerUser.staffId)
  );
  const [draftGroupId, setDraftGroupId] = useState(null);

  const [isOnBookingPageDisabled, setIsBookingPageDisabled] = useState(visibility === privateVisiblity); // Disable state for the checkbox
  
  const bookingTypeId = bookingType.id;

  const scrollToSection = (ref) => {
    setTimeout(() => {
      const section2 = document.getElementById(ref);
      section2?.scrollIntoView(true);
    }, 100);
  };

  const handleChange = (event) => {

    const { value } = event.target;
    setVisibility(value);
    if (value === "private") {
      // If private is selected, disable and uncheck the checkbox
      setIsPublic(false)
      setIsVisibleOnBookingPage(false);
      setIsBookingPageDisabled(true);
    } else {
      setIsPublic(true)
      // Public-to-staff visibility stays available on the free tier.
      setIsBookingPageDisabled(false);
    }
  };
  const handleVisibleOnBookingPageChange = () => {
    setIsVisibleOnBookingPage(!isVisibleOnBookingPage);
  };



  const [bookingPerDay, setbookingPerDay] = useState(
    bookingTypeId ? bookingType.bookingPerDay : null
  );
  const [increments, setIncrements] = React.useState(
    bookingTypeId ? bookingType.increments : 30
  );
  const [advancedOpen, setAdvancedOpen] = useState(
    bookingType
      ? !bookingType.bookingPerDay || bookingType.increments !== 30
      : false
  );

  const [bookingTypeCategoryName, setSearchImages] = useState(getBookingCategory(bookingType?.bookingTypeCategoryId));

  const [anchorEl, setAnchorEl] = useState(null);
  const [image, setImage] = useState(bookingTypeId ? bookingType.image : 0);
  const [assignedStaffs, setAssignedStaffs] = useState([]);
  const assignedStaffsSyncedForBookingRef = useRef(null);


  useEffect(() => {
    const syncKey = Number(selectedBookingType?.id || bookingType?.id || 0);
    const shouldSync =
      assignedStaffsSyncedForBookingRef.current !== syncKey || assignedStaffs.length === 0;
    if (!shouldSync) return;

    const existingStaffs = selectedBookingType?.assignedStaffs?.map(
      (assignedStaff) => ({
        staffId: Number(assignedStaff.staffId),
        groupId: Number(assignedStaff.groupId),
        permissionId: Number(assignedStaff?.permissionId),
        hostNotifyEnabled: assignedStaff?.hostNotifyEnabled !== false,
        hostReminderMinutes:
          Number.isFinite(Number(assignedStaff?.hostReminderMinutes)) && Number(assignedStaff?.hostReminderMinutes) > 0
            ? Number(assignedStaff?.hostReminderMinutes)
            : 60,
      })
    );
    if (existingStaffs?.length > 0) {
      setAssignedStaffs(existingStaffs);
    } else {
      setAssignedStaffs([
        {
          staffId: providerUser.staffId,
          groupId: custom
            ? groupId
            : getSelectedGroupIdForStaff(providerUser.staffId),
          hostNotifyEnabled: true,
          hostReminderMinutes: 60,
        },
      ]);
    }
    assignedStaffsSyncedForBookingRef.current = syncKey;
  }, [
    selectedBookingType,
    bookingType?.id,
    providerUser?.staffId,
    assignedStaffs.length,
    custom,
    groupId,
    getSelectedGroupIdForStaff,
  ]);

  const primaryAssignment = bookingType?.assignedStaffs?.[0];
  const scheduleGroup = businessStaffs?.find(staff => Number(staff.id) === Number(primaryAssignment?.staffId))?.workingHourGroups?.find(group => Number(group.id) === Number(primaryAssignment?.groupId));
  const userTimeZone = bookingType?.scheduleTimezone || scheduleGroup?.timeZone?.timezone || providerUser?.timeZone?.timezone || Intl.DateTimeFormat().resolvedOptions()?.timeZone || 'UTC';

  const handleFormSubmit = (send) => {

    if (draftGroupId && custom) {
      updateWorkingHourGroup({
        variables: {
          input: {
            isForBusiness: 0,
            isDraft: true,
          },
          groupId: draftGroupId,
        },
      })
        .then((result) => { })
        .catch((error) => {
          console.log(error);
        });
    } else if (draftGroupId && !custom) {
      deleteWorkingHourGroup({
        variables: {
          groupId: draftGroupId,
        },
      })
        .then((result) => {
          //TODO: dispatch
          // refetch({
          //   staffId: providerUser.staffId,
          //   hours24: HourFormat(),
          // });
          // groupRefetch();
        })
        .catch((error) => {
          console.log(error);
          //TODO: dispatch
          // refetch({
          //   staffId: providerUser.staffId,
          //   hours24: HourFormat(),
          // });
          // groupRefetch();
        });
    }
    setUpdating(true);
    var final = {
      bookingTypeId: parseInt(bookingType?.id) ?? null,
      bookingSize: bookingType.bookingSize,
      bookingPerDay: bookingPerDay ? parseInt(bookingPerDay) : null,
      increments,
      isVisibleToStaff: visibility !== "private" ? true : false,
      isPublic: isPublic,
      displayOnBookingPage: isVisibleOnBookingPage,
      image,
      start: start,
      end: end,
      recurringInterval: recurringInterval,
      recurring: recurring,
      calendarSystem,
      scheduleTimezone: userTimeZone,
      bookingApproval: bookingApproval,
      assignedStaffs: assignedStaffs,
      createdBy: providerUser.staffId
    };
    handleSubmit(final);
    handleDialog(false)
  };

  const tooltipData = {
    dateRange: "Set a range of dates during which you can accept meetings.",
    duration: "Specify the duration of this booking type, up to a maximum of 12 hours.",
    schedule: "Select an existing schedule or define custom hours specific to this booking type.",
    link: "Provide a unique booking link to describe this booking type.",
    visibilityToAssignedStaff: "This booking type is visible only to assigned staff members.",
    visibilityToAllStaff: "This booking type is visible to all staff members.",
    displayOnBookingPage: "Display this booking type on the Timely365 Booking Page for public booking.",
    color: "Pick a color to represent this booking type visually.",
    maxInvitees: "Define the maximum number of invitees for this booking type.",
    approval: "Availability is based on members' default settings, which can be modified in the staff portal.",
    bufferTime: "Specify buffer time between consecutive bookings to allow for preparation or breaks.",
  };

  const handleDialog = () => {
    setIsScheduleSettings(false);
    onClose();
  };

  const customActions =
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        padding: "20px",
      }}
    >
      <AccessRestrictedButton disabled={isDisabled || !datesValid} onClick={handleFormSubmit}>
        Save & Close
      </AccessRestrictedButton>
    </div>

  return (
    <CustomDialog openDialog={isScheduleSettings} setOpenDialog={null} onDialogClose={onClose} actions={customActions} >

      {checkPlanNeeded && (
        <UpgradePlan
          featureName={upgradeFeature ?? "Advanced Booking features"}
          requiredPlanId={standardPlanRequired}
          applyExemption={false}
          pricingProduct="booking"
          onClose={() => setCheckPlanNeeded(false)}
        />
      )}

      <Box>
        {showSection === "host" && <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {<BookingTypeHostAvailability
            isUpdateMode={isUpdateMode}
            allStaffs={allStaffs}
            assignedStaffs={assignedStaffs}
            setAssignedStaffs={setAssignedStaffs}
            hasAdvancedBookingAccess={hasAdvancedBookingAccess}
            providerUser={providerUser}
            getSelectedGroupIdForStaff={getSelectedGroupIdForStaff}
            bookingTypeCategoryName={bookingTypeCategoryName}
            groupId={groupId}
            setGroupId={setGroupId}
            selectedBookingType={selectedBookingType}
            draftGroupId={draftGroupId}
            setDraftGroupId={setDraftGroupId}
            getDefaultGroupId={getDefaultGroupId}
            custom={custom}
            setCustom={setCustom}
            selectedBusiness={selectedBusiness}
          />

          }

        </div>}
        {showSection === "setting" &&
          <div>

            {/* Date Range */}
            <Accordion defaultExpanded sx={{ boxShadow: 'none', border: 'none' }} >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography><div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "10px",
                  }}
                >
                  <h4 id="dateRange">Invitees can schedule</h4>
                  <GenericTooltip
                    title={tooltipData.dateRange}
                  />
                </div></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Box>
                    {(preferences.ethiopianEnabled || calendarSystem === 'ethiopic') && <><TextField select fullWidth size="small" label="Schedule calendar" value={calendarSystem} disabled={isDisabled || !preferences.ethiopianEnabled} onChange={event => setCalendarSystem(event.target.value)} sx={{ mb: 1 }}>
                      <MenuItem value="gregory">Gregorian</MenuItem><MenuItem value="ethiopic">Ethiopian</MenuItem>
                    </TextField>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Monthly/yearly repetition follows this calendar. Date fields use your display calendar. Timezone: {userTimeZone}. Changing the schedule calendar affects future recurrence dates; saved appointment times stay unchanged.</Typography>
                    {calendarSystem === 'ethiopic' && <Alert severity="info" sx={{ mb: 1 }}>Monthly repetition uses the Ethiopian day of the start date. Dates that do not exist, such as Pagume 21, are skipped. Pagume 6 repeats only in leap years.</Alert>}
                    <Button size="small" disabled={!preferences.ethiopianEnabled || preferences.savingPreference || preferences.defaultCalendar === calendarSystem} onClick={() => preferences.setDefaultCalendar(calendarSystem)}>Use as workspace default for new booking types</Button>
                    {preferences.preferenceError && <Alert severity="error">{preferences.preferenceError}</Alert>}</>}
                    {/* Radio buttons for choosing between Booking Availability and Recurring Schedule */}
                    <RadioGroup row value={selectedOption} onChange={handleOptionChange}>
                      <FormControlLabel value="non-recurrence" control={<Radio />} label="Non recurring" />
                      <FormControlLabel value="recurrence" control={<Radio />} label="Recurring Schedule" />
                    </RadioGroup>

                    {/* Booking Availability Controls */}
                    {selectedOption === 'non-recurrence' && (
                      <Box mt={1}>
                        <FormControl fullWidth>
                          <DateRangeView
                            isDisabled={isDisabled}
                            start={start}
                            setStart={setStart}
                            end={end}
                            setEnd={setEnd}
                            providerUser={providerUser}
                            userTimeZone={userTimeZone}
                            calendarSystem={preferences.displayCalendar}
                            onValidityChange={setDatesValid}
                          />
                        </FormControl>
                      </Box>
                    )}

                    {/* Recurring Schedule Controls */}
                    {selectedOption === 'recurrence' && (
                      <Box mt={2}>
                        <FormControl fullWidth sx={{ border: 'none' }}>
                          <RecurringView
                            isDisabled={isDisabled}
                            start={start}
                            setStart={setStart}
                            end={end}
                            setEnd={setEnd}
                            recurring={recurring}
                            setRecurring={setRecurring}
                            recurringInterval={recurringInterval}
                            setRecurringInterval={setRecurringInterval}
                            providerUser={providerUser}
                            userTimeZone={userTimeZone}
                            calendarSystem={preferences.displayCalendar}
                            onValidityChange={setDatesValid}
                          />
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </div>
              </AccordionDetails>
            </Accordion>
            <Divider />
            {/* Duration */}
            <BufferTimeSettings
              tooltipData={tooltipData}
              increments={increments}
              setIncrements={setIncrements}
              isDisabled={isDisabled}
              advancedOpen={advancedOpen}
              setAdvancedOpen={setAdvancedOpen}
              bookingPerDay={bookingPerDay}
              setBookingPerDay={setbookingPerDay}
              bookingType={bookingType}
            />

          </div>}
        {showSection === "privacy" &&
          <Privacy 
            visibility={visibility}
            handleChange={handleChange}
            isDisabled={isDisabled}
            isVisibleOnBookingPage={isVisibleOnBookingPage}
            handleVisibleOnBookingPageChange={handleVisibleOnBookingPageChange}
            isOnBookingPageDisabled={isOnBookingPageDisabled}
            tooltipData={tooltipData}
            bookingTypeCategoryName={bookingTypeCategoryName}
          />
        }
      </Box>

    </CustomDialog >
  );
};

export default BookingTypeTime;
